import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, fromEvent, merge, Subject, timer, Subscription } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ScreenLockerService {

    private noJob$: Observable<any>;
    private timer$: Subscription;
    private timeOutMilliSeconds: number;
    private idleSubscription: Subscription;
    private countdownSubscription?: Subscription;
    private deadline = 0;

    private remainingSeconds$ = new BehaviorSubject<number>(0);

    public expired$: Subject<boolean> = new Subject<boolean>();

    constructor() {}

    public startWatching(timeOutSeconds: number): Observable<any> {

        this.noJob$ = merge(
            fromEvent(document, 'mousemove'),
            fromEvent(document, 'click'),
            fromEvent(document, 'mousedown'),
            fromEvent(document, 'keypress'),
            fromEvent(document, 'DOMMouseScroll'),
            fromEvent(document, 'mousewheel'),
            fromEvent(document, 'touchmove'),
            fromEvent(document, 'MSPointerMove'),
            fromEvent(window, 'mousemove'),
            fromEvent(window, 'resize'),
        );

        this.timeOutMilliSeconds = timeOutSeconds * 1000;
        this.deadline = Date.now() + this.timeOutMilliSeconds;
        this.updateRemaining();

        this.idleSubscription = this.noJob$.subscribe((res) => {
            this.resetTimer();
        });

        this.startTimer();
        this.startCountdown();

        return this.expired$;
    }

    private startTimer(): void {
        this.timer$ = timer(this.timeOutMilliSeconds, this.timeOutMilliSeconds).subscribe((res) => {
            this.expired$.next(true);
        });
    }

    public resetTimer(): void {
        if (this.timer$) {
            this.timer$.unsubscribe();
        }
        this.deadline = Date.now() + this.timeOutMilliSeconds;
        this.updateRemaining();
        this.startTimer();
    }

    public stopTimer(): void {
        if (this.timer$) {
            this.timer$.unsubscribe();
        }
        if (this.idleSubscription) {
            this.idleSubscription.unsubscribe();
        }
        if (this.countdownSubscription) {
            this.countdownSubscription.unsubscribe();
            this.countdownSubscription = undefined;
        }
        this.deadline = 0;
        this.remainingSeconds$.next(0);
    }

    public remainingSeconds(): Observable<number> {
        return this.remainingSeconds$.asObservable();
    }

    private startCountdown(): void {
        if (this.countdownSubscription) {
            this.countdownSubscription.unsubscribe();
        }

        this.countdownSubscription = timer(0, 1000).subscribe(() => {
            this.updateRemaining();
        });
    }

    private updateRemaining(): void {
        if (!this.deadline) {
            this.remainingSeconds$.next(0);
            return;
        }

        const remainingMs = Math.max(0, this.deadline - Date.now());
        this.remainingSeconds$.next(Math.ceil(remainingMs / 1000));
    }

}
